// extracted by mini-css-extract-plugin
export default {"title":"P6-z","warning":"Q6-z","sizeOptionsLegendText":"R6-z"};